import { PasswordStrengthSchema, type PasswordStrength } from '@/entities'

export type PasswordRequirementId = 'length' | 'lower' | 'upper' | 'digit' | 'special' | 'noRepeat'

export type PasswordRequirement = {
    id: PasswordRequirementId
}

const isPasswordRequirementEnabled = (id: PasswordRequirementId, strength: PasswordStrength, minLength: number) => {
    if (strength === 'none') {
        return false
    }

    if (id === 'length') {
        return minLength > 0
    }

    return true
}

export const getPasswordPolicyRequirements = (strength: PasswordStrength, minLength: number): PasswordRequirement[] => {
    const levelIndex = PasswordStrengthSchema.options.indexOf(strength)
    const requirements: PasswordRequirement[] = []

    if (levelIndex >= 1) {
        requirements.push({ id: 'length' })
    }

    if (levelIndex >= 2) {
        requirements.push({ id: 'lower' })
        requirements.push({ id: 'upper' })
        requirements.push({ id: 'digit' })
    }

    if (levelIndex >= 3) {
        requirements.push({ id: 'special' })
    }

    if (levelIndex >= 4) {
        requirements.push({ id: 'noRepeat' })
    }

    return requirements.filter((requirement) => isPasswordRequirementEnabled(requirement.id, strength, minLength))
}

export const isPasswordRequirementMet = (id: PasswordRequirementId, password: string, minLength: number) => {
    const checks: Record<PasswordRequirementId, (value: string) => boolean> = {
        length: (value) => value.length >= minLength,
        lower: (value) => /[a-z]/.test(value),
        upper: (value) => /[A-Z]/.test(value),
        digit: (value) => /\d/.test(value),
        special: (value) => /[-+_!@#$%^&*.,?<>=]/.test(value),
        noRepeat: (value) => !/(.)\1\1/.test(value),
    }

    return checks[id](password)
}
